"use strict";
var PopStateType = (function () {
    function PopStateType() {
    }
    PopStateType.HIDDEN = 'hidden';
    PopStateType.CONTENT_SWAP = 'content_swap';
    PopStateType.CONTENT_SETUP = 'content_setup';
    PopStateType.PRE_POSITION = 'pre_position';
    PopStateType.PRE_SHOW = 'pre_show';
    PopStateType.SHOWING = 'showing';
    PopStateType.CONTENT_REMOVE = 'content_remove';
    PopStateType.PRE_HIDE = 'pre_hide';
    return PopStateType;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PopStateType;
